import React from 'react'

export const Floor = ({ color }) => {
	return (
		<mesh
			position={[-640, 0, -450]}
			rotation={[-Math.PI / 2, 0, 0]}
			receiveShadow
			castShadow
		>
			{/* <boxGeometry args={[1, 0.1, 2]} /> */}
			<planeGeometry args={[1280, 900]} />
			<meshStandardMaterial color={color} />
		</mesh>
	)
}
